import { t } from 'i18next';
import * as yup from 'yup';

export const campaignSchema = yup.object().shape({
  pathSegment: yup
    .string()
    .optional()
    .required(t('site.campaigns.campaign.settings.campaignPathRequired'))
    .test('not-empty', t('site.campaigns.campaign.settings.campaignPathRequired'), (value) => {
      return value !== undefined && value !== null && value.trim().length > 0;
    }),
  program: yup
    .string()
    .nullable()
    .required(t('site.campaigns.campaign.settings.programRequired'))
    .test('not-null', t('site.campaigns.campaign.settings.programRequired'), (value) => {
      return value !== null && value !== undefined && value !== '';
    }),
  listId: yup
    .string()
    .nullable()
    .required(t('site.campaigns.campaign.settings.listRequired'))
    .test('not-null', t('site.campaigns.campaign.settings.listRequired'), (value) => {
      return value !== null && value !== undefined && value !== '';
    }),
  tagline: yup.string().nullable(),
  // A wallet campaign is defined by the wallet its cards are vaulted in, so the backend requires the
  // connection for that program and rejects a save without one.
  connectionId: yup
    .string()
    .nullable()
    .when('program', {
      is: 'Wallet',
      then: (schema) =>
        schema
          .required(t('site.campaigns.campaign.settings.walletConnectionRequired'))
          .test(
            'not-null',
            t('site.campaigns.campaign.settings.walletConnectionRequired'),
            (value) => value !== null && value !== undefined && value !== '',
          ),
    }),
  requireId: yup.boolean(),
  requiredMinimumAge: yup.string().nullable(),
  venueId: yup.string().nullable(),
  emailVerificationTemplateId: yup.string().nullable(),
  registrationCompleteTemplateId: yup.string().nullable(),
  registrationMissingPhotosTemplateId: yup.string().nullable(),
  noPhotoEmailReminderDelay: yup.number().nullable(),
  enrollmentByRequestOnly: yup.boolean(),
  requestEnrollmentTemplateId: yup.string().nullable(),
  registrationIncompleteTemplateId: yup.string().nullable(),
  content: yup.object().shape({
    introduction: yup.object().shape({
      enabled: yup.boolean(),
      marketingInfo: yup.string().nullable(),
    }),
    registration: yup.object().shape({
      confirmation: yup.string().nullable(),
      callToActionButtonTitle: yup.string().nullable(),
      callToActionButtonLink: yup.string().nullable(),
    }),
    photoUpload: yup.object().shape({
      instructions: yup.string().nullable(),
      success: yup.string().nullable(),
    }),
  }),
});
